import { SVG, Svg, G, Element as SvgElement } from '@svgdotjs/svg.js';
import { FittingSidePosition, Utils } from 'core/utils';

import { PositioningHints
       } from '../../collage-designer/stage/placeholder/overlays/action-bar/action-bar.component'; // eslint-disable-line
import { DragInfo, HandleBase, Placement, RoughBox } from './handle.base';

export class RotationHandle extends HandleBase
{
  private offset: number;
  private position: FittingSidePosition;
  private diameter: number;
  private _actionBarPositioningHints: PositioningHints;

  constructor(element: SvgElement, handleGroup: G)
  {
    const mainSVG = (<any>handleGroup).root();
    const stageViewbox = mainSVG.viewbox();
    const factor = stageViewbox.height / mainSVG.rbox().height;
    const diameter = 31 * factor;
    const strokeWidth = 1 * factor;
    const control = handleGroup.nested().css('cursor', 'grab');

    control.width(diameter);
    control.height(diameter);

    control.circle(diameter)
      .fill('white')
      .stroke({ width: strokeWidth })
      .addClass('handle-rotation-control');

    control
      .image(Utils.url('./assets/img/icons/rotate.svg'))
      .size(diameter * 0.7, diameter * 0.7)
      .move(diameter * 0.15, diameter * 0.15);
    super(element, control);

    this.diameter = diameter;
    this.offset = (diameter + strokeWidth);
    this.position = FittingSidePosition.Right;
    this._actionBarPositioningHints = {};
  }

  public get actionBarPositioningHints(): PositioningHints
  {
    return this._actionBarPositioningHints;
  }

  protected updateControl(bounds: RoughBox): void {
    switch (this.position) {
      case FittingSidePosition.Right:
        this.roughCenter(this.control,
                         bounds.x + bounds.width + this.offset,
                         bounds.y + bounds.height / 2,
                         this.diameter,
                         this.diameter);

        this._actionBarPositioningHints = {
          marginRight: 48
        };

        break;
      default: // won't be reached
        throw new Error('not implemented');
    }
  }

  protected drag(info: DragInfo): Placement {
    return {
      rotation: (Utils.rotationToOrigin(info.absolute.x, info.absolute.y)
                 + this.offsetAngle)
    };
  }

  private get offsetAngle(): number {
    switch (this.position) {
      case FittingSidePosition.Top: return 90;
      case FittingSidePosition.Right: return 0;
      case FittingSidePosition.Bottom: return -90;
      case FittingSidePosition.Left: return 180;
      default:
        return 0; // won't be reached
    }
  }
}
